import initialState from './initialState';

const reducers = [];

export default function reducer(state = initialState, action) {
  let newState;
  /* istanbul ignore next */
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}
